<div class="row margin20">
    <div class="col-xs-12 col-md-12 text-center">
        <h3 class="offerHeading">In-store Offers for you.</h3>
    </div>
    <div class="col-xs-12 col-md-12">
        <div class="cross topLeftCross"></div>
        <div class="addContainer" *ngIf="addLocation=='pickupconfirm'">
            <div class="col-xs-12 col-md-12 nopad">
                <div class="travelInsuraceContainer">
                    <a href="{{travelUrl}}" target="_blank" class="getQuotesbtn">GET QUOTE</a>
                </div>
            </div>
            <div class="col-xs-12 col-md-12 nopad">
                <div class="cyberInsuraceContainer">
                    <a href="{{cyberUrl}}" target="_blank" class="getQuotesbtn">BUY NOW</a>
                </div>
            </div>
        </div>
        <div class="addContainer" *ngIf="addLocation=='reject'">
            <div class="col-xs-12 col-md-12 nopad">
                <div class="ulipInsuraceContainer">
                    <h3 class="header-card clearfix">ULIP investment plan helps
                        <br>
                        increase wealth exponentially
                    </h3>
                    <a href="{{ProdTypeSession==='TWGI'? ulipRejectUrl:ulipRejectUrl4W}}" target="_blank"
                        class="getQuotesbtn">GET QUOTE</a>
                </div>
            </div>
            <div class="col-xs-12 col-md-12 nopad">
                <div class="healthInsuraceContainer">
                    <h3 class="header-card clearfix">Secure your family's health
                        <br>
                        with Family Health Insurance
                    </h3>
                    <a href="{{ProdTypeSession==='TWGI'? healthRejectUrl:healthRejectUrl4W}}" target="_blank"
                        class="getQuotesbtn">GET QUOTE</a>
                </div>
            </div>
        </div>
        <div class="addContainer" *ngIf="addLocation=='multitab'">
            <div class="col-xs-12 col-md-12 nopad">
                <div class="ulipInsuraceContainer">
                    <h3 class="header-card clearfix">ULIP investment plan helps
                        <br>
                        increase wealth exponentially
                    </h3>
                    <a href="{{ProductType==='TWGI'? ulipUrl:ulipUrl4W}}"
                        (click)="analyticsCall('ULIP', 'ULIP investment', ProductType==='TWGI'? ulipUrl:ulipUrl4W)"
                        target="_blank" class="getQuotesbtn">GET QUOTE</a>
                </div>
            </div>
            <div class="col-xs-12 col-md-12 nopad">
                <div class="healthInsuraceContainer">
                    <h3 class="header-card clearfix">Secure your family's health
                        <br>
                        with Family Health Insurance
                    </h3>
                    <a href="{{ProductType==='TWGI'? healthUrl:healthUrl4W}}"
                        (click)="analyticsCall('HGI', 'Health Insurance', ProductType==='TWGI'? healthUrl:healthUrl4W)"
                        target="_blank" class="getQuotesbtn">GET QUOTE</a>
                </div>
            </div>
        </div>
        <div class="cross bottoRightCross"></div>
    </div>
</div>